import { type ReactNode } from "react"
import { cn } from "~/utils/helpers"

type PageToolbarProps = {
  children: ReactNode
  className?: string
}

const PageToolbar = ({ children, className }: PageToolbarProps) => {
  return (
    <div
      className={cn(
        "sticky top-header z-[9] bg-medium border-b border-base px-4 py-2 flex items-center gap-2",
        className,
      )}
    >
      {children}
    </div>
  )
}

export default PageToolbar
